import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { TablePagination } from '@mui/material';
import { TbArrowBackUp } from "react-icons/tb";
import { formatDate } from '../../../utils/Utils';

function Row(props) {
    const { row, selected, openDetails } = props;

    return (
        <>
            <TableRow
                sx={{ '& > *': { borderBottom: 'unset' } }}
                onClick={() => openDetails(row.details)}
                selected={selected}
            >
                <TableCell />
                <TableCell component="th" scope="row">
                    {row.id}
                </TableCell>
                <TableCell align="right">{formatDate(row.date)}</TableCell>
                <TableCell align="right">{row.transect_length} m</TableCell>
                <TableCell align="right">{row.macro_weight} kg</TableCell>
                <TableCell align="right">{row.excursion}</TableCell>
            </TableRow>
        </>
    );
}

export default function DataList({ data, goBack, openDetails, selectedRow, excursion }) {
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const formatData = useCallback((data) => {
        const rows = [];
        if (!data) return rows;
        data.forEach(item => {
            rows.push({
                id: item.id,
                site: item.site_name,
                date: item.sample_date,
                macro_weight: item.macro_weight,
                transect_length: item.transect_length,
                excursion: excursion || "Aucune",
                details: item
            });
        });
        return rows;
    }, [excursion]);

    useEffect(() => {
        setRows(formatData(data));
    }, [data, formatData]);



    const visibleRows = useMemo(
        () =>
            [...rows]
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [page, rowsPerPage, rows],
    );

    return (
        <>
            <TableContainer className='data-list-container' sx={{ maxHeight: "50vh" }}>
                <Table aria-label="collapsible table" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <IconButton onClick={goBack}>
                                    <TbArrowBackUp />
                                </IconButton>
                            </TableCell>
                            <TableCell>Prélèvements</TableCell>
                            <TableCell align="right">Date</TableCell>
                            <TableCell align="right">Longueur transecte</TableCell>
                            <TableCell align="right">Poids macro</TableCell>
                            <TableCell align="right">Expédition</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {visibleRows.map((row) => (
                            <Row key={row.id} row={row} selected={selectedRow && selectedRow.user_id === row.id} openDetails={openDetails} />
                        ))}
                    </TableBody>

                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                rowsPerPageOptions={[5, 10, 25]}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    );
}
